import React, {Component, PropTypes} from 'react'
import cs from 'classnames'
import {connect} from 'react-redux'
import styles from './faq.scss'
import stylesExtra from 'css/extra/buttons.scss'
import {filter} from 'lodash/collection'
import {sortBy} from 'lodash/collection'
import {getFaq, setFaqFilter} from 'state/actions'
import Category from './categories'
import HtmlContent from 'elements/HtmlContent'
import FilterInput from 'elements/FilterInput'
import Collapse from 'react-collapse'
import {Motion, spring} from 'react-motion'
import {getFileNameAndUrl} from 'lib/helpers'

import i18n from 'lib/i18n'
const _ = i18n('faq')

// TODO move this to own component, use thumbnails, add size, download original name…
const KsFileValue = ({itemId, file}) => {
	const {url, name} = getFileNameAndUrl('faq', itemId, file)
	return (
		<a href={url} target="_blank" rel="noopener noreferrer">{name}</a>
	)
}
const ListSectionDom = ({title, children}) => (
	<div className={styles.cat}>
		<div className={styles.listSectionTitle}>{title}</div>
        {children}
	</div>
)
ListSectionDom.propTypes = {
	title: PropTypes.node,
	children: PropTypes.node,
}

// TODO factor out the rotating arrow from here and collapseTd
const OpenCloseArrow = ({open, className}) => (
	<Motion style={{d: spring(open ? 0 : -90)}}>{({d}) =>
		<div className={cs(styles.arrow, className)} style={{transform: `rotate(${d}deg)`}}>
			&nbsp;
		</div>
	}</Motion>
)

const getIcon = () => {
    try {
        return require(`resources/images/print-black-18dp.svg`)
    } catch(err) {
        return require(`resources/images/icn-no-result.svg`)
    }
}

const FaqDom = ({q, a, open, onClick}) => (
	<div className={styles.faq}>
		<div onClick={onClick} className={styles.questionCont}>
			<OpenCloseArrow open={open}/>
            <div className={styles.question}>{q}</div>
            <img className={styles.printIcon} src={getIcon()}
                onClick={(e) => {
                e.preventDefault()
                const theWindow = window.open('', 'PRINT', 'height=600,width=800')
                    theWindow.document.write('<html style="overflow: scroll"><head><title>' + q  + '</title>')
                    theWindow.document.write('</head><body style="height: 100%; overflow: scroll;">')
                    theWindow.document.write('<h2>'+ q + '</h2>')
                    theWindow.document.write(a)
                    theWindow.document.write('</body></html>')
                    theWindow.document.close() // IE >= 10
                    theWindow.focus() // IE >= 10
                    theWindow.print()
            }}/>
		</div>
		<Collapse isOpened={Boolean(open)}>
			<div className={styles.content}>
                <HtmlContent className={styles.answer} content={a}/>

            </div>
        </Collapse>
	</div>
)
FaqDom.propTypes = {
	q: PropTypes.string.isRequired,
	a: PropTypes.string.isRequired,
	open: PropTypes.bool,
	onClick: PropTypes.func,
}

const FaqSection = ({catId, items, isOpened, switchIt}) => {
	return (
		<ListSectionDom
			title={<Category plain id={catId}/>}
		>
			{items.map(({_id, Q, A}) =>
				<FaqDom key={_id} q={Q} a={A} open={isOpened[_id]} onClick={() => switchIt(_id)}/>
			)}
		</ListSectionDom>
	)
}
FaqSection.propTypes = {
	items: PropTypes.array,
	catId: PropTypes.string,
	isOpened: PropTypes.object,
	switchIt: PropTypes.func,
}

const FaqPageDom = ({title, subtitle, filter, onFilter, children}) => (
	<div id={styles.faqModule}>
		<div className={styles.mainSubDiv}>
			<div className={`${styles.mainTitleDiv} bottom-border`}>
				<div className={styles.mainTitleContainer}>
					<h2>{title}</h2>
					<h3>{subtitle}</h3>
				</div>
				<FilterInput filter={filter} setFilter={onFilter}/>
			</div>
			<div className={styles.catsContainer}>
				{children}
			</div>
		</div>
	</div>
)
FaqPageDom.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	filter: PropTypes.string,
	onFilter: PropTypes.func.isRequired,
	children: PropTypes.node,
}

@connect(
	({faq}) => faq,
	{getFaq, setFaqFilter}
)
export default class Faq extends Component {
	static propTypes = {
		getFaq: PropTypes.func.isRequired,
		setFaqFilter: PropTypes.func.isRequired,
		items: PropTypes.array,
		filter: PropTypes.string,
	}

	constructor(props) {
		super(props)
		this.state = {
			isOpened: {},
		}
	}
	switch(id) {
		const isOpened = this.state
		isOpened[id] = !isOpened[id]
		this.setState({isOpened})
	}

	componentDidMount() {this.update()}
	update() {this.props.getFaq()}

	orderItems(items) {
		const cats = {}
		items.forEach(item => {
			const {_id, categoryId, A, Q, attachments} = item
			if (!cats[categoryId]) {cats[categoryId] = []}
			cats[categoryId].push({_id, A, Q, attachments})
		})
		return Object.keys(cats).map(categoryId => {
			const sortCats = sortBy(cats[categoryId], cat => cat.Q.toLowerCase().replace(/\s+/g, ''))
			return {categoryId, content: sortCats}
		})
	}

	render() {
		const {isOpened} = this.state
		const {items, filter, setFaqFilter} = this.props
		const itemsId = items.map((m, i) => ({...m, id: i}))
		const lowerFilter = filter.toLowerCase()
		const filteredItems = filter ? itemsId.filter(item => (
				item.Q.toLowerCase().includes(lowerFilter) ||
				item.A.toLowerCase().includes(lowerFilter))
			) : itemsId
		const orderedItems = this.orderItems(filteredItems)

		return (
			<FaqPageDom
				title={_('title')}
				subtitle={_('subtitle')}
				filter={filter}
				onFilter={setFaqFilter}
			>
				{orderedItems.map(row =>
					<FaqSection
						key={row.catId}
						catId={row.categoryId}
						items={row.content}
						isOpened={isOpened}
						switchIt={id => this.switch(id)}
					/>
				)}
			</FaqPageDom>
		)
	}
}



// WEBPACK FOOTER //
// ./components/faq.jsx